module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "song"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "iconfont icon-home",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-search"
  })]), _vm._v(" "), _c('div', {
    staticClass: "song-info"
  }, [_c('div', {
    class: {
      'zhuan': _vm.zhuan
    },
    attrs: {
      "id": "picture"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.recordCover,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lyric"
  }, [_c('ul', {
    staticClass: "lrc-inner",
    staticStyle: {
      "transition": "all 0.3s ease-out"
    },
    style: ({
      'top': (-20 * _vm.currentIndex + 'px')
    })
  }, _vm._l((_vm.afterlyric), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'font': index === _vm.currentIndex
      },
      style: ({
        'color': index === _vm.currentIndex ? '#fc378c' : '#8e9ba1'
      }),
      attrs: {
        "id": index
      }
    }, [_vm._v("\n                    " + _vm._s(item[1]) + "\n                ")])
  }))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-content"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "author"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('i', {
    staticClass: "iconfont icon-love"
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-xiazai1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "play"
  }, [_c('div', {
    attrs: {
      "id": "skPlayer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ac5119c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/song.vue
// module id = 247
// module chunks = 0